import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-child-endangerment-policy',
    templateUrl: './child-endangerment-policy.component.html',
    styleUrl: './child-endangerment-policy.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChildEndangermentPolicyComponent {

}
